<template>
  <SignatureSave
      :maxWidth="500"
      :setTitle="setTitle"
      :signatureData="signatureData"
      width="100%"
      height="150px"
      @onSignature="(response) => $emit('onSignature', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketPricing from '@/services/ticket-pricing'

  import SignatureSave from '@/components/_Part/_Modal/_Save/Signature'

  export default {
    name: 'Signature',
    props: [
      'pricingToken'
    ],
    emits: [
      'onSignature'
    ],
    components: {
      SignatureSave
    },
    methods: {
      setTitle() {
        return 'Podpis'
      },
      signatureData(ItemForm) {
        return TicketPricing
          .uploadSignature({
            pricingToken: this.pricingToken,
            data: ItemForm
          })
      }
    }
  }
</script>
